
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/message-group",
      function () {
        return require("private-next-pages/x/api/chat/message-group.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/message-group"])
      });
    }
  